import React from "react";
import styled, { css } from "styled-components";
import { COLORS } from "@/react/theme/constants";

const StyledDiv = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 4px;
  background: ${COLORS.primary};
  cursor: col-resize;
  user-select: none;
  touch-action: none;
  transition: opacity 0.3s ease;

  ${({ isResizing }) =>
    isResizing &&
    css`
      background: blue;
      opacity: 1;
    `};

  @media (hover: hover) {
    & {
      opacity: 0;
    }

    *:hover > & {
      opacity: 1;
    }
  }
`;
export default function Resizer({ resizeHandler, isResizing }) {
  return (
    <StyledDiv
      onMouseDown={resizeHandler}
      onTouchStart={resizeHandler}
      isResizing={isResizing}
    />
  );
}
